export function isDevelopmentModeEnabled(): boolean {
  const envVal = window.__ENV__?.ENABLE_DEVELOPMENT_MODE;
  if (envVal && envVal !== '__ENABLE_DEVELOPMENT_MODE_PLACEHOLDER__') {
    return envVal === 'true';
  }
  return import.meta.env.ENABLE_DEVELOPMENT_MODE === 'true';
}
